import ServerSideGrid from './ServerSideGrid';

export default function GridWrapper(props) {
  return <ServerSideGrid {...props} />;
}
